import Popover from '@material-ui/core/Popover';
/**
 * Import da biblioteca "styled-components", que permite escrever
 * CSS simples para os componentes sem acontecer conflitos com os
 * nomes das clases, são escritos entre Tagged Templates Literals(``).
 */
import styled from 'styled-components';

/**
 * Estilização do componente Wrap
 */
export const Wrap = styled.div`
  height: 100%;
  @media (max-width: 768px) {
    height: calc(100% - 20px);
  }

  .MuiPaper-root {
    height: 100%;
  }

  .svg-button {
    padding: 0;
    margin: 0;
    border: none;
    background: transparent;
    color: #7b8084;
    &:hover {
      color: #3c71dd;
    }
    @media (max-width: 768px) {
      color: #3c71dd;
    }
    &:disabled {
      color: #b6b6b6;
    }
  }

  .filter-mobile-button {
    position: absolute;
    z-index: 10;
    top: 31px;
    right: 15px;
  }

  .attr-head {
    position: relative;
    height: 43px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #e6e6e6;
    margin: 0 45px 5px 0;

    h3 {
      font-family: Roboto;
      font-style: normal;
      font-weight: 300;
      font-size: 16px;
      line-height: 19px;
      color: #5e6366;
    }
    @media (max-width: 768px) {
      display: none;
    }

    &.with-buttons {
      margin: 0 45px 5px 0;
    }
  }

  .attr-table-actions {
    width: 100%;
    height: 40px;
    padding: 0px 3px;
    display: none;
    align-items: center;

    &.active {
      display: flex;
      @media (max-width: 768px) {
        display: none;
      }
    }

    &.inactive {
      display: flex;
    }

    .actions {
      width: 70%;
      .action {
        background: none;
        border: none;
        text-decoration: none;
        color: #797e82;
        padding-right: 14px;

        .a-icon {
          margin-top: 3.5px;

          &.disabled {
            path {
              fill: #b6b6b6;
            }
          }
        }

        &:hover {
          color: #3c71dd;
        }

        .disabled {
          color: #b6b6b6;
        }

        .MuiSvgIcon-fontSizeSmall {
          font-size: 1rem;
        }
      }

      .enabled {
        color: #3c71dd;
      }
    }

    /* .filters {
      text-align: right;
      width: 30%;
      margin: 0 45px 0 0;

      &.without-actions {
        width: 100%;
      }

      .svg-button {
        padding-left: 14px;
      }
    } */

    .filters {
      display: flex;
      justify-content: flex-end; /* Alinha todos os itens à direita */
      align-items: center; /* Garante que os itens fiquem centralizados verticalmente */
      width: 100%; /* Garante que a div ocupe toda a largura */
      padding-right: 40px; /* Adiciona um espaçamento à direita */
    }

    .filters .svg-button {
      padding-left: 0; /* Remove o padding se necessário */
    }

    .filters .svg-button {
      padding-left: 0; /* Remove o padding se necessário */
    }
  }

  .layer-tabs {
    margin-bottom: 24px;
    border-bottom: 1px solid #e5e5e5;
    margin-right: 20px;
    .MuiTabs-root {
      min-height: 30px;
      span[class^='PrivateTabIndicator'] {
        height: 3px;
        background: #3c71dd;
      }
    }
    .MuiTab-root {
      font-family: Roboto;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 16px;
      color: #5e6366;
      text-transform: none;
      min-height: 30px;
      min-width: 80px;
      margin-right: 20px;
      padding: 3px 4px;
    }
    .Mui-selected {
      color: #3c71dd;
    }
    @media (max-width: 768px) {
      display: none;
    }
  }

  .no-data {
    display: flex;
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    color: #df773d;
    @media (max-width: 768px) {
      font-size: 12px;
      line-height: 14px;
      height: 50%;
    }
  }

  .table-area {
    height: calc(100% - 87px ${({ tabs }) => (tabs ? '- 53px' : '')});
    @media (max-width: 768px) {
      height: calc(100% ${({ tabs }) => (tabs ? '- 51px' : '')});
    }
  }

  .loader {
    position: absolute;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(255, 255, 255, 0.8);
    color: #5e5e5e;
    z-index: 5;
    @media (max-width: 768px) {
      height: calc(50vh - 53px);
      top: 60px;
    }
  }
`;

/**
 * Estilização do componente StyledPopoverFilter
 */
export const StyledPopoverFilter = styled(Popover)`
  z-index: 1600 !important;

  .MuiPopover-paper {
    padding: 25px 30px;
    min-width: 250px;
    width: calc(100% - 290px);
  }
`;

/**
 * Estilização do componente StyledPopupFormColumn
 */
export const StyledPopupFormColumn = styled(Popover)`
  z-index: 1600 !important;

  .MuiPopover-paper {
    height: 120px;
    width: 730px;
    padding: 40px 30px;
    overflow-x: initial;
    overflow-y: initial;
    .arrow-form-column {
      position: absolute;
      border-left: 11px solid transparent;
      border-right: 11px solid transparent;
      border-bottom: 12px solid #fff;
      left: 12px;
      top: -12px;
      opacity: 1;
      transition: opacity 250ms;
    }
  }
`;

/**
 * Estilização do componente StyledPopupHideAndConfigureLabel
 */
export const StyledPopupHideAndConfigureLabel = styled(Popover)`
  z-index: 1600 !important;

  .MuiPopover-paper {
    height: 66px;
    border-radius: 3px;
    padding: 21px 36px;
    min-width: 144px;
    overflow-x: initial;
    overflow-y: initial;
    .arrow-configure-label {
      position: absolute;
      border-left: 11px solid transparent;
      border-right: 11px solid transparent;
      border-bottom: 12px solid #fff;
      left: 12px;
      top: -12px;
      opacity: 1;
      transition: opacity 250ms;
    }
  }
`;

/**
 * Estilização do componente ModalBody
 */
// export const ModalBody = styled.div`
//   padding-top: 32px;
//   p {
//     font-family: Roboto;
//     font-style: normal;
//     font-weight: 300;
//     font-size: 12px;
//     line-height: 16px;
//     color: #5e6366;
//   }

//   .MuiButton-root {
//     background: #3c71dd;
//     border-radius: 3px;
//     width: 185.14px;
//     height: 40px;
//   }

//   .MuiButton-label {
//     font-family: Roboto;
//     font-style: normal;
//     font-weight: 600;
//     font-size: 14px;
//     line-height: 22px;
//     text-align: center;
//     color: #ffffff;
//     text-transform: none;
//   }
// `;
